import Index from '../../pages/hjwq/mid-autumn/index';
import Help from '../../pages/hjwq/mid-autumn/help';

const base = 'mid-autumn';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/midAutumn.js